import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M1 12C1 5.925 5.925 1 12 1s11 4.925 11 11-4.925 11-11 11c-1.936 0-3.757-.5-5.338-1.38L1.4 22.6l.98-5.262A10.95 10.95 0 0 1 1 12m6.147-5.353c.654-.655 1.527-.713 1.998-.69.435.02.776.272.984.564l.952 1.334a1.5 1.5 0 0 1-.16 1.932l-.674.673c.223.544.67 1.42 1.272 2.021s1.477 1.05 2.02 1.273l.675-.674a1.5 1.5 0 0 1 1.931-.16l1.335.951c.291.209.544.55.564.984.022.471-.036 1.344-.69 1.999-1.067 1.066-2.741 1.077-4.264.659-1.55-.426-3.13-1.34-4.197-2.406-1.065-1.066-1.98-2.646-2.406-4.197-.418-1.523-.407-3.197.66-4.263",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const brandSocialChatWhatsapp = { render };
export {
  brandSocialChatWhatsapp as default,
  render
};
//# sourceMappingURL=brand-social-chat-whatsapp.svg.js.map
